import { render, staticRenderFns } from "./online-video.vue?vue&type=template&id=0b6ed11a&functional=true"
import script from "./online-video.vue?vue&type=script&lang=js"
export * from "./online-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports